// Brand glyphs for social sign-in providers, shared by both apps. Callers size
// them via the surrounding button's `[&_svg]:size-*`. Each app composes
// only the providers its SDK config exposes into a per-app `PROVIDER_ICONS`
// map, so the provider set can diverge without forking the glyphs.

export function AppleIcon() {
	return (
		<svg
			aria-hidden='true'
			viewBox='0 0 24 24'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701'
				fill='currentColor'
			/>
		</svg>
	)
}

export function GoogleIcon() {
	return (
		<svg
			aria-hidden='true'
			viewBox='0 0 24 24'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M12 5.04c1.74 0 3.3.6 4.53 1.78l3.39-3.39A11.04 11.04 0 0012 0C7.39 0 3.34 2.7 1.28 6.64l3.96 3.08A6.52 6.52 0 0112 5.04z'
				fill='#EA4335'
			/>
			<path
				d='M23.5 12.18c0-.86-.08-1.69-.22-2.48H12v4.7h6.45a5.58 5.58 0 01-2.42 3.66l3.91 3.04c2.28-2.11 3.56-5.21 3.56-8.92z'
				fill='#4285F4'
			/>
			<path
				d='M5.24 14.28l-.83.64-2.94 2.29A11.96 11.96 0 0012 24c3.24 0 5.96-1.07 7.94-2.91l-3.91-3.04a7.16 7.16 0 01-10.38-2.22z'
				fill='#34A853'
			/>
			<path
				d='M1.28 6.64A11.96 11.96 0 000 12c0 1.94.46 3.77 1.28 5.39l3.96-3.08a6.96 6.96 0 01-.3-2.31c0-.8.14-1.57.39-2.29L1.28 6.64z'
				fill='#FBBC05'
			/>
		</svg>
	)
}

export function XIcon() {
	return (
		<svg
			aria-hidden='true'
			viewBox='0 0 24 24'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z'
				fill='currentColor'
			/>
		</svg>
	)
}
